module.exports = __webpack_public_path__ + "img/s5Img1Big.aa52efdf.png";